import type { BriefingMail } from './briefing';

export interface VorschlagEintrag {
  quelle: 'mail' | 'ticket' | 'rechnung';
  id: string;
  titel: string;
  minuten: number;
  score: number;
  frist: string | null;
}

const MAIL_PRIO_SCORE: Record<string, number> = { dringend: 100, hoch: 70, mittel: 40, niedrig: 10 };
const TICKET_PRIO_SCORE: Record<string, number> = { kritisch: 100, hoch: 70, mittel: 40, niedrig: 10 };
const TICKET_ZU = ['erledigt', 'geschlossen'];

function fristBonus(frist: string | null, heuteIso: string): number {
  if (!frist) return 0;
  if (frist <= heuteIso) return 50;
  const tage = (Date.parse(frist) - Date.parse(heuteIso)) / 86_400_000;
  return tage <= 3 ? 25 : 0;
}

export function baueArbeitsvorschlag(args: {
  mails: BriefingMail[];
  tickets: { id: string; titel: string; status: string; prioritaet: string | null; faellig_am: string | null }[];
  rechnungen: { id: string; titel: string; status: string; faelligkeitsdatum: string | null }[];
  heuteIso: string;
}): VorschlagEintrag[] {
  const eintraege: VorschlagEintrag[] = [];

  for (const m of args.mails) {
    eintraege.push({
      quelle: 'mail', id: m.id,
      titel: m.erkannte_aufgabe || m.betreff,
      minuten: m.zeitschaetzung_min ?? 10,
      frist: m.frist_datum,
      score: (MAIL_PRIO_SCORE[m.prioritaet] ?? 40) + (m.ist_notfall ? 20 : 0) + fristBonus(m.frist_datum, args.heuteIso),
    });
  }
  for (const t of args.tickets) {
    if (TICKET_ZU.includes(t.status)) continue;
    const frist = t.faellig_am ? t.faellig_am.slice(0, 10) : null;
    eintraege.push({
      quelle: 'ticket', id: t.id, titel: t.titel, minuten: 10, frist,
      score: (TICKET_PRIO_SCORE[t.prioritaet ?? 'mittel'] ?? 40) + fristBonus(frist, args.heuteIso),
    });
  }
  for (const r of args.rechnungen) {
    const frist = r.faelligkeitsdatum ? r.faelligkeitsdatum.slice(0, 10) : null;
    eintraege.push({
      quelle: 'rechnung', id: r.id, titel: r.titel, minuten: 5, frist,
      score: (r.status === 'offen' ? 35 : 45) + fristBonus(frist, args.heuteIso),
    });
  }

  return eintraege.sort((a, b) => b.score - a.score).slice(0, 10);
}
